/*
 * @Author: Marte
 * @Date:   2017-07-11 17:56:20
 * @Last Modified by:   Marte
 * @Last Modified time: 2017-07-12 11:25:58
 */

'use strict';
angular
    .module('tManageMentServiceModule', [
        'tCreateUserModule',
        'editTenantModule',
        'resouceLimitModule',
        'regionalOfficialModule',
        'uploadIsiconModule',
        'listOfRngOfficialsModule',
        'smsVerificationModule',
        'createEditServiceModule',
        'tenantServicesInfoModule',
        'editApplictionModule',
        'previewLogoModule',
        'checkManuIpModule',
        'showTenantInfoModule',
        'settingTransmissionModule',
        'effectiveTimeModule',
        'setBillingModule',
        'addPapersiteModule',
        'createTerritoryPointModule',
        'bindRegionModule',
        'createdBrokeNewsAccountModule',
        'manageConfigPackageDetailsModule', // 套餐详情模块
        'setBillingBindTipModule',
    ])
    .factory('tManageMentService', [
        '$modal',
        '$q',
        function ($modal, $q) {
            return {

                /**
                 * [tenantCreate description] 新建租户
                 * @return  {[type]}  [return description]
                 */
                tenantCreate: function () {
                    var defer = $q.defer();
                    var modalInstance = $modal.open({
                        templateUrl: './manageConfig/tenantManageMent/service/tenantCreateUser/tenantCreateUser_tpl.html',
                        windowClass: 'tenantCreateUser-createUser-window',
                        backdrop: false,
                        controller: 'tCreateUserCtrl',
                        resolve: {},
                    });
                    // 关闭弹窗
                    modalInstance.result.then(
                        function (result) {
                            defer.resolve(result);
                        },
                        function () {
                            defer.reject('cancle');
                        }
                    );
                    return defer.promise;
                },

                /**
                 * [editTenant description]
                 * @return  {[type]}  [return description]
                 */
                editTenant: function (item) {
                    var defer = $q.defer();
                    var modalInstance = $modal.open({
                        templateUrl: './manageConfig/tenantManageMent/service/editTenant/editTenant_tpl.html',
                        windowClass: 'editTenant',
                        backdrop: false,
                        controller: 'editTenantCtrl',
                        resolve: {
                            item: function () {
                                return item;
                            },
                        },
                    });
                    // 关闭弹窗
                    modalInstance.result.then(
                        function (result) {
                            defer.resolve(result);
                        },
                        function () {
                            defer.reject('cancle');
                        }
                    );
                    return defer.promise;
                },

                /**
                 * [resouceLimit description]
                 * @return  {[type]}  [return description]
                 */
                resouceLimit: function (item) {
                    var defer = $q.defer();
                    var modalInstance = $modal.open({
                        templateUrl: './manageConfig/tenantManageMent/service/resouceLimit/resouceLimit.html',
                        windowClass: 'resouceLimit',
                        backdrop: false,
                        controller: 'resouceLimitCtrl',
                        resolve: {
                            item: function () {
                                return item;
                            },
                        },
                    });
                    // 关闭弹窗
                    modalInstance.result.then(
                        function (result) {
                            defer.resolve(result);
                        },
                        function () {
                            defer.reject('cancle');
                        }
                    );
                    return defer.promise;
                },

                /**
                 * [resouceLimit description] 设置传播力指数
                 * @type {[type]}
                 */
                settingTransmission: function (item) {
                    var defer = $q.defer();
                    var modalInstance = $modal.open({
                        templateUrl: './manageConfig/tenantManageMent/service/settingTransmission/settingTransmission.html',
                        windowClass: 'settingTransmission',
                        backdrop: false,
                        controller: 'settingTransmissionCtrl',
                        resolve: {
                            item: function () {
                                return item;
                            },
                        },
                    });
                    // 关闭弹窗
                    modalInstance.result.then(
                        function (result) {
                            defer.resolve(result);
                        },
                        function () {
                            defer.reject('cancle');
                        }
                    );
                    return defer.promise;
                },

                /**
                 * [resouceLimit description] 地区相关官员
                 * @type {[type]}
                 */
                regionalOfficia: function (item) {
                    var defer = $q.defer();
                    var modalInstance = $modal.open({
                        templateUrl: './manageConfig/tenantManageMent/service/regionalOfficial/regionalOfficial.html',
                        windowClass: 'regionalOfficia',
                        backdrop: false,
                        controller: 'regionalOfficialCtrl',
                        resolve: {
                            item: function () {
                                return item;
                            },
                        },
                    });
                    // 关闭弹窗
                    modalInstance.result.then(
                        function (result) {
                            defer.resolve(result);
                        },
                        function () {
                            defer.reject('cancle');
                        }
                    );
                    return defer.promise;
                },

                /**
                 * [uploadIsicon description] 上传头像
                 * @param {Number} [aspectRatio] [description] 宽高比
                 * @return {[type]} [description]
                 */
                uploadIsicon: function (res, aspectRatio) {
                    var defer = $q.defer();
                    var modalInstance = $modal.open({
                        templateUrl: './manageConfig/tenantManageMent/service/regionalOfficial/uploadIsicon/uploadIsicon.html',
                        windowClass: 'uploadIsicon',
                        backdrop: false,
                        controller: 'uploadIsiconCtrl',
                        resolve: {
                            params: function () {
                                return res;
                            },
                            aspectRatio: function () {
                                return aspectRatio;
                            },
                        },
                    });
                    // 关闭弹窗
                    modalInstance.result.then(
                        function (result) {
                            defer.resolve(result);
                        },
                        function () {
                            defer.reject('cancle');
                        }
                    );
                    return defer.promise;
                },
                listOfRngOfficials: function (item) {
                    var defer = $q.defer();
                    var modalInstance = $modal.open({
                        templateUrl: './manageConfig/tenantManageMent/service/listOfRegionalOfficial/listOfRngOfficial_tpl.html',
                        windowClass: 'listOfficialContent',
                        backdrop: false,
                        controller: 'listOfRngOfficialsCtrl',
                        resolve: {
                            item: function () {
                                return item;
                            },
                        },
                    });
                    // 关闭弹窗
                    modalInstance.result.then(
                        function (result) {
                            defer.resolve(result);
                        },
                        function () {
                            defer.reject('cancle');
                        }
                    );
                    return defer.promise;
                },
                smsVerification: function (item, num) {
                    var defer = $q.defer();
                    var modalInstance = $modal.open({
                        templateUrl: './manageConfig/tenantManageMent/service/smsVerification/smsVerification_tpl.html',
                        windowClass: 'smsVerification_win',
                        backdrop: false,
                        controller: 'smsVerificationCtrl',
                        resolve: {
                            item: function () {
                                return {
                                    item: item,
                                    num: num,
                                };
                            },
                        },
                    });
                    // 关闭弹窗
                    modalInstance.result.then(
                        function (result) {
                            defer.resolve(result);
                        },
                        function () {
                            defer.reject('cancle');
                        }
                    );
                    return defer.promise;
                },
                createEditService: function (item, num) {
                    var defer = $q.defer();
                    var modalInstance = $modal.open({
                        templateUrl: './manageConfig/tenantManageMent/service/createEditService/createEditService_tpl.html',
                        windowClass: 'createEditService_win',
                        backdrop: false,
                        controller: 'createEditServiceCtrl',
                        resolve: {
                            item: function () {
                                return {
                                    item: item,
                                    num: num,
                                };
                            },
                        },
                    });
                    // 关闭弹窗
                    modalInstance.result.then(
                        function (result) {
                            defer.resolve(result);
                        },
                        function () {
                            defer.reject('cancle');
                        }
                    );
                    return defer.promise;
                },
                tenantServiceInfo: function (item) {
                    var defer = $q.defer();
                    var modalInstance = $modal.open({
                        templateUrl: './manageConfig/tenantManageMent/service/tenantServicesInfo/tenantServiceInfo_tpl.html',
                        windowClass: 'tenantServiceInfo_win',
                        backdrop: false,
                        controller: 'tenantServicesInfoCtrl',
                        resolve: {
                            item: function () {
                                return item;
                            },
                        },
                    });
                    // 关闭弹窗
                    modalInstance.result.then(
                        function (result) {
                            defer.resolve(result);
                        },
                        function () {
                            defer.reject('cancle');
                        }
                    );
                    return defer.promise;
                },
                editAppliction: function (item) {
                    var defer = $q.defer();
                    var modalInstance = $modal.open({
                        templateUrl: './manageConfig/tenantManageMent/service/editAppliction/editAppliction_tpl.html',
                        windowClass: 'editAppliction',
                        backdrop: false,
                        controller: 'editApplictionCtrl',
                        resolve: {
                            item: function () {
                                return item;
                            },
                        },
                    });
                    // 关闭弹窗
                    modalInstance.result.then(
                        function (result) {
                            defer.resolve(result);
                        },
                        function () {
                            defer.reject('cancle');
                        }
                    );
                    return defer.promise;
                },
                previewLogo: function (item) {
                    var defer = $q.defer();
                    var modalInstance = $modal.open({
                        templateUrl: './manageConfig/tenantManageMent/service/previewLogo/previewLogo.html',
                        windowClass: 'previewLogo',
                        backdrop: false,
                        controller: 'previewLogoCtrl',
                        resolve: {
                            item: function () {
                                return item;
                            },
                        },
                    });
                    // 关闭弹窗
                    modalInstance.result.then(
                        function (result) {
                            defer.resolve(result);
                        },
                        function () {
                            defer.reject('cancle');
                        }
                    );
                    return defer.promise;
                },
                checkManuIp: function () {
                    var defer = $q.defer();
                    var modalInstance = $modal.open({
                        templateUrl: './manageConfig/tenantManageMent/service/checkManuIp/checkManuIp_tpl.html',
                        windowClass: 'checkManuIp',
                        backdrop: false,
                        controller: 'checkManuIpCtrl',
                        resolve: {},
                    });
                    // 关闭弹窗
                    modalInstance.result.then(
                        function (result) {
                            defer.resolve(result);
                        },
                        function () {
                            defer.reject('cancle');
                        }
                    );
                    return defer.promise;
                },
                showTenantInfo: function (item) {
                    var defer = $q.defer();
                    var modalInstance = $modal.open({
                        templateUrl: './manageConfig/tenantManageMent/service/showTenantInfo/showTenantInfo_tpl.html',
                        windowClass: 'showTenantInfo',
                        backdrop: false,
                        controller: 'showTenantInfoCtrl',
                        resolve: {
                            item: function () {
                                return item;
                            },
                        },
                    });
                    // 关闭弹窗
                    modalInstance.result.then(
                        function (result) {
                            defer.resolve(result);
                        },
                        function () {
                            defer.reject('cancle');
                        }
                    );
                    return defer.promise;
                },

                /**
                 * [addPapersite description] 新增媒体
                 */
                addPapersite: function () {
                    var defer = $q.defer();
                    var modalInstance = $modal.open({
                        templateUrl: './manageConfig/tenantManageMent/service/addPapersite/addPapersite_tpl.html',
                        windowClass: 'add-papersite-window',
                        backdrop: false,
                        controller: 'addPapersiteCtrl',
                        resolve: {},
                    });
                    // 关闭弹窗
                    modalInstance.result.then(
                        function (result) {
                            defer.resolve(result);
                        },
                        function () {
                            defer.reject('cancel');
                        }
                    );
                    return defer.promise;
                },
                createTerritoryPoint: function (token, item, isDetail) {
                    var defer = $q.defer();
                    var modalInstance = $modal.open({
                        templateUrl: './manageConfig/tenantManageMent/service/territoryPoint/create.html',
                        windowClass: 'territory-point-create',
                        backdrop: false,
                        controller: 'territoryPointCreateCtrl',
                        resolve: {
                            item: function () {
                                return {
                                    token: token,
                                    item: item,
                                    isDetail: isDetail,
                                };
                            },
                        },
                    });
                    // 关闭弹窗
                    modalInstance.result.then(
                        function (result) {
                            defer.resolve(result);
                        },
                        function () {
                            defer.reject('cancle');
                        }
                    );
                    return defer.promise;
                },

                /**
                 * @description: 绑定地域
                 * @param {type}
                 * @return:
                 */
                bindRegion: function (moduleId) {
                    var defer = $q.defer();
                    var modalInstance = $modal.open({
                        templateUrl: './manageConfig/tenantManageMent/service/bindRegion/bindRegion_tpl.html',
                        windowClass: '',
                        backdrop: false,
                        controller: 'bindRegionCtrl',
                        resolve: {
                            moduleId: moduleId,
                        },
                    });
                    // 关闭弹窗
                    modalInstance.result.then(
                        function (result) {
                            defer.resolve(result);
                        },
                        function () {
                            defer.reject('cancle');
                        }
                    );
                    return defer.promise;
                },
                createdBrokeNewsAccount: function (tokens, item, isDetail) {
                    var defer = $q.defer();
                    var modalInstance = $modal.open({
                        templateUrl: './manageConfig/tenantManageMent/service/brokeNewsAccount/create.html',
                        windowClass: 'territory-point-create',
                        backdrop: false,
                        controller: 'createdBrokeNewsAccountCtrl',
                        resolve: {
                            item: function () {
                                return {
                                    token: tokens,
                                    item: item,
                                    isDetail: isDetail,
                                };
                            },
                        },
                    });
                    // 关闭弹窗
                    modalInstance.result.then(
                        function (result) {
                            defer.resolve(result);
                        },
                        function () {
                            defer.reject('cancle');
                        }
                    );
                    return defer.promise;
                },

                /**
                 * [effectiveTime description] 功能模块有效时间
                 */
                effectiveTime: function (item) {
                    var defer = $q.defer();
                    var modalInstance = $modal.open({
                        templateUrl: './manageConfig/tenantManageMent/service/effectiveTime/effectiveTime_tpl.html',
                        windowClass: 'effectiveTimeWindow',
                        backdrop: false,
                        controller: 'effectiveTimeCtrl',
                        resolve: {
                            item: function () {
                                return item;
                            },
                        },
                    });
                    // 关闭弹窗
                    modalInstance.result.then(
                        function (result) {
                            defer.resolve(result);
                        },
                        function () {
                            defer.reject('cancel');
                        }
                    );
                    return defer.promise;
                },
                packageDetail: function(item) {
                    var defer = $q.defer();
                    var modalInstance = $modal.open({
                        templateUrl: './manageConfig/tenantManageMent/service/packageDetails/package_tpl.html',
                        windowClass: 'tcxqWindow',
                        backdrop: false,
                        controller: 'manageConfigPackageDetailsCtrl',
                        resolve: {
                            item: function () {
                                return item;
                            },
                        },
                    });
                    // 关闭弹窗
                    modalInstance.result.then(
                        function (result) {
                            defer.resolve(result);
                        },
                        function () {
                            defer.reject('cancel');
                        }
                    );
                    return defer.promise;
                },

                /*
                /**
                 * [setBillingModule description] 设置租户的计费模块
                 */
                setBilling: function (item) {
                    var defer = $q.defer();
                    var modalInstance = $modal.open({
                        templateUrl: './manageConfig/tenantManageMent/service/setBillingModule/setBillingModule_tpl.html',
                        windowClass: 'setBillingModuleWindow',
                        backdrop: false,
                        controller: 'setBillingModuleCtrl',
                        resolve: {
                            item: function () {
                                return item;
                            },
                        },
                    });
                    // 关闭弹窗
                    modalInstance.result.then(
                        function (result) {
                            defer.resolve(result);
                        },
                        function () {
                            defer.reject('cancel');
                        }
                    );
                    return defer.promise;
                },

                bindTip: function(item) {
                    var defer = $q.defer();
                    var modalInstance = $modal.open({
                        templateUrl: './manageConfig/tenantManageMent/service/bindTip/bindTip.html',
                        windowClass: 'setBillingBindTipWindow',
                        backdrop: false,
                        controller: 'setBillingBindTipCtrl',
                        resolve: {
                            item: function () {
                                return item;
                            },
                        },
                    });
                    // 关闭弹窗
                    modalInstance.result.then(
                        function (result) {
                            defer.resolve(result);
                        },
                        function () {
                            defer.reject('cancel');
                        }
                    );
                    return defer.promise;
                },
            };
        },
    ]);
